import type { VerticalAlignment } from '../../../interfaces';
import { ComponentTypes } from '../../../interfaces';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { ContentLayoutProps } from './types';
import { classes } from '../../utils/classes';

const mapVerticalAlignment = (type: VerticalAlignment) =>
  ({ top: 'flex-start', middle: 'center', bottom: 'flex-end' })[type];

export const ContentLayout = ({ data, className }: ContentLayoutProps) => {
  const {
    behavior_paragraph_columns_layout_mobile: columnsMobile = '1',
    behavior_paragraph_columns_layout_desktop: columnsDesktop = '1',
    behavior_paragraph_column_gap: colGap = '0',
    behavior_paragraph_row_gap: rowGap = '0',
    behavior_paragraph_margin: margin,
    behavior_paragraph_padding: padding,
    behavior_paragraph_background_color: backgroundColor = 'transparent',
    behavior_paragraph_alignment_vertical: verticalAlignment = 'top',
    behavior_paragraph_borderRadius: borderRadius = '0',
  } = data;

  return (
    <div
      className={classes(
        className,
        'c_cms-contentLayout grid',
        columnsMobile && `grid-cols-${columnsMobile}`, // TW classes are registered in default-cms.css
        columnsDesktop && `md:grid-cols-${columnsDesktop}`,
        borderRadius && borderRadius !== '0' && 'overflow-hidden', // clip children so the rounded corners are visible
      )}
      style={{
        background: backgroundColor,
        borderRadius,
        margin: margin || undefined,
        padding: padding || undefined,
        alignItems: mapVerticalAlignment(verticalAlignment),
        gap: `${rowGap || 0} ${colGap || 0}`,
      }}
    >
      {data.paragraph?.map((item) => (
        <div
          key={item.id}
          className="[&_.\_c\_cms-contentLayout]:h-full [&_.\_c\_cms-contentLayout]:w-full [&_.\_c\_cms-contentLayout]:xl:container [&_.\_c\_cms-contentLayout]:xl:mx-auto!"
        >
          <ComponentRecognizer item={item} />
        </div>
      ))}
    </div>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({
  [ComponentTypes.ContentLayout]: ContentLayout,
});
